module.exports = __webpack_public_path__ + "media/img/pod-card-a2122ed4.svg";